import SurveyEvaluationScalesListLoader from './Loaders/SurveyEvaluationScaleListLoader';
import SurveyEvaluationScalesTable from './parts/SurveyEvaluationScaleTable';

function index() {
  return (
    <SurveyEvaluationScalesListLoader>
      <SurveyEvaluationScalesTable />
    </SurveyEvaluationScalesListLoader>
  );
}

export default index;
